import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neoris-minidashboard-user',
  templateUrl: './minidashboard-user.component.html',
  styleUrls: ['./minidashboard-user.component.css']
})
export class MinidashboardUserComponent implements OnInit {

  siteId:string
  constructor() { 
    console.log('minidashboard constructor')
  }

  ngOnInit(): void {
    this.siteId = localStorage.getItem('site')
  }

}
